<template>
  <section class="tw-py-24 tw-bg-white">
    <div class="tw-container tw-mx-auto tw-px-6">
      <div class="tw-text-center tw-mb-16">
        <h2 class="tw-text-4xl md:tw-text-5xl tw-font-bold tw-text-gray-900 tw-mb-4 tw-leading-tight">
          Everything You Need to Run a High-Performing Event
        </h2>
      </div>
      <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-6 tw-max-w-6xl tw-mx-auto">
        <!-- Feature 1 -->
        <div class="tw-relative tw-rounded-2xl tw-overflow-hidden tw-shadow-md hover:tw-shadow-xl tw-transition-all tw-duration-300 tw-min-h-[200px] tw-transform hover:tw-scale-105 tw-cursor-pointer">
          <div class="tw-absolute tw-inset-0">
            <img 
              src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&h=400&fit=crop&q=90" 
              alt="Intelligent Matching"
              class="tw-w-full tw-h-full tw-object-cover tw-transition-transform tw-duration-300 hover:tw-scale-110"
              loading="lazy"
            />
            <div class="tw-absolute tw-inset-0 tw-bg-gradient-to-br tw-from-primary-600/85 tw-via-primary-700/90 tw-to-primary-900/95 hover:tw-from-primary-600/90 hover:tw-via-primary-700/95 hover:tw-to-primary-900/98 tw-transition-all tw-duration-300"></div>
          </div>
          <div class="tw-relative tw-p-8 tw-h-full tw-flex tw-flex-col tw-justify-between">
            <div>
              <div class="tw-w-12 tw-h-12 tw-bg-white/20 tw-backdrop-blur-sm tw-rounded-xl tw-flex tw-items-center tw-justify-center tw-mb-4 tw-transition-all tw-duration-300 hover:tw-bg-white/30 hover:tw-scale-110 hover:tw-rotate-6">
                <svg class="tw-w-6 tw-h-6 tw-text-white tw-transition-transform tw-duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 class="tw-text-lg tw-font-bold tw-text-white tw-mb-3 tw-drop-shadow-lg tw-transition-transform tw-duration-300">Intelligent Matching</h3>
              <p class="tw-text-white/95 tw-leading-relaxed tw-text-sm tw-drop-shadow-md">AI-powered algorithm creates optimal B2B connections based on business needs</p>
            </div>
          </div>
        </div>

        <!-- Feature 2 -->
        <div class="tw-relative tw-rounded-2xl tw-overflow-hidden tw-shadow-md hover:tw-shadow-xl tw-transition-all tw-duration-300 tw-min-h-[200px] tw-transform hover:tw-scale-105 tw-cursor-pointer">
          <div class="tw-absolute tw-inset-0">
            <img 
              src="https://images.unsplash.com/photo-1561070791-2526d30994b5?w=600&h=400&fit=crop&q=90" 
              alt="White-Label Platform"
              class="tw-w-full tw-h-full tw-object-cover tw-transition-transform tw-duration-300 hover:tw-scale-110"
              loading="lazy"
            />
            <div class="tw-absolute tw-inset-0 tw-bg-gradient-to-br tw-from-blue-600/85 tw-via-blue-700/90 tw-to-blue-900/95 hover:tw-from-blue-600/90 hover:tw-via-blue-700/95 hover:tw-to-blue-900/98 tw-transition-all tw-duration-300"></div>
          </div>
          <div class="tw-relative tw-p-8 tw-h-full tw-flex tw-flex-col tw-justify-between">
            <div>
              <div class="tw-w-12 tw-h-12 tw-bg-white/20 tw-backdrop-blur-sm tw-rounded-xl tw-flex tw-items-center tw-justify-center tw-mb-4 tw-transition-all tw-duration-300 hover:tw-bg-white/30 hover:tw-scale-110 hover:tw-rotate-6">
                <svg class="tw-w-6 tw-h-6 tw-text-white tw-transition-transform tw-duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
                </svg>
              </div>
              <h3 class="tw-text-lg tw-font-bold tw-text-white tw-mb-3 tw-drop-shadow-lg tw-transition-transform tw-duration-300">White-Label Platform</h3>
              <p class="tw-text-white/95 tw-leading-relaxed tw-text-sm tw-drop-shadow-md">Fully customizable platform that matches your brand identity</p>
            </div>
          </div>
        </div>

        <!-- Feature 3 -->
        <div class="tw-relative tw-rounded-2xl tw-overflow-hidden tw-shadow-md hover:tw-shadow-xl tw-transition-all tw-duration-300 tw-min-h-[200px] tw-transform hover:tw-scale-105 tw-cursor-pointer">
          <div class="tw-absolute tw-inset-0">
            <img 
              src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=600&h=400&fit=crop&q=90" 
              alt="Sponsor Integration"
              class="tw-w-full tw-h-full tw-object-cover tw-transition-transform tw-duration-300 hover:tw-scale-110"
              loading="lazy"
            />
            <div class="tw-absolute tw-inset-0 tw-bg-gradient-to-br tw-from-purple-600/85 tw-via-purple-700/90 tw-to-purple-900/95 hover:tw-from-purple-600/90 hover:tw-via-purple-700/95 hover:tw-to-purple-900/98 tw-transition-all tw-duration-300"></div>
          </div>
          <div class="tw-relative tw-p-8 tw-h-full tw-flex tw-flex-col tw-justify-between">
            <div>
              <div class="tw-w-12 tw-h-12 tw-bg-white/20 tw-backdrop-blur-sm tw-rounded-xl tw-flex tw-items-center tw-justify-center tw-mb-4 tw-transition-all tw-duration-300 hover:tw-bg-white/30 hover:tw-scale-110 hover:tw-rotate-6">
                <svg class="tw-w-6 tw-h-6 tw-text-white tw-transition-transform tw-duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 class="tw-text-lg tw-font-bold tw-text-white tw-mb-3 tw-drop-shadow-lg tw-transition-transform tw-duration-300">Sponsor Integration</h3>
              <p class="tw-text-white/95 tw-leading-relaxed tw-text-sm tw-drop-shadow-md">Seamless sponsor visibility and engagement tracking</p>
            </div>
          </div>
        </div>

        <!-- Feature 4 -->
        <div class="tw-relative tw-rounded-2xl tw-overflow-hidden tw-shadow-md hover:tw-shadow-xl tw-transition-all tw-duration-300 tw-min-h-[200px] tw-transform hover:tw-scale-105 tw-cursor-pointer">
          <div class="tw-absolute tw-inset-0">
            <img 
              src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop&q=90" 
              alt="Real-Time Analytics"
              class="tw-w-full tw-h-full tw-object-cover tw-transition-transform tw-duration-300 hover:tw-scale-110"
              loading="lazy"
            />
            <div class="tw-absolute tw-inset-0 tw-bg-gradient-to-br tw-from-green-600/85 tw-via-green-700/90 tw-to-green-900/95 hover:tw-from-green-600/90 hover:tw-via-green-700/95 hover:tw-to-green-900/98 tw-transition-all tw-duration-300"></div>
          </div>
          <div class="tw-relative tw-p-8 tw-h-full tw-flex tw-flex-col tw-justify-between">
            <div>
              <div class="tw-w-12 tw-h-12 tw-bg-white/20 tw-backdrop-blur-sm tw-rounded-xl tw-flex tw-items-center tw-justify-center tw-mb-4 tw-transition-all tw-duration-300 hover:tw-bg-white/30 hover:tw-scale-110 hover:tw-rotate-6">
                <svg class="tw-w-6 tw-h-6 tw-text-white tw-transition-transform tw-duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
              </div>
              <h3 class="tw-text-lg tw-font-bold tw-text-white tw-mb-3 tw-drop-shadow-lg tw-transition-transform tw-duration-300">Real-Time Analytics</h3>
              <p class="tw-text-white/95 tw-leading-relaxed tw-text-sm tw-drop-shadow-md">Live dashboards and comprehensive post-event reporting</p>
            </div>
          </div>
        </div>

        <!-- Feature 5 -->
        <div class="tw-relative tw-rounded-2xl tw-overflow-hidden tw-shadow-md hover:tw-shadow-xl tw-transition-all tw-duration-300 tw-min-h-[200px] tw-transform hover:tw-scale-105 tw-cursor-pointer">
          <div class="tw-absolute tw-inset-0">
            <img 
              src="https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=600&h=400&fit=crop&q=90" 
              alt="Responsive Platform"
              class="tw-w-full tw-h-full tw-object-cover tw-transition-transform tw-duration-300 hover:tw-scale-110"
              loading="lazy"
            />
            <div class="tw-absolute tw-inset-0 tw-bg-gradient-to-br tw-from-orange-600/85 tw-via-orange-700/90 tw-to-orange-900/95 hover:tw-from-orange-600/90 hover:tw-via-orange-700/95 hover:tw-to-orange-900/98 tw-transition-all tw-duration-300"></div>
          </div>
          <div class="tw-relative tw-p-8 tw-h-full tw-flex tw-flex-col tw-justify-between">
            <div>
              <div class="tw-w-12 tw-h-12 tw-bg-white/20 tw-backdrop-blur-sm tw-rounded-xl tw-flex tw-items-center tw-justify-center tw-mb-4 tw-transition-all tw-duration-300 hover:tw-bg-white/30 hover:tw-scale-110 hover:tw-rotate-6">
                <svg class="tw-w-6 tw-h-6 tw-text-white tw-transition-transform tw-duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" />
                </svg>
              </div>
              <h3 class="tw-text-lg tw-font-bold tw-text-white tw-mb-3 tw-drop-shadow-lg tw-transition-transform tw-duration-300">Responsive Platform</h3>
              <p class="tw-text-white/95 tw-leading-relaxed tw-text-sm tw-drop-shadow-md">Platform is responsive for all screens - desktop, tablet, and mobile</p>
            </div>
          </div>
        </div>

        <!-- Feature 6 -->
        <div class="tw-relative tw-rounded-2xl tw-overflow-hidden tw-shadow-md hover:tw-shadow-xl tw-transition-all tw-duration-300 tw-min-h-[200px] tw-transform hover:tw-scale-105 tw-cursor-pointer">
          <div class="tw-absolute tw-inset-0">
            <img 
              src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=600&h=400&fit=crop&q=90" 
              alt="Dedicated Support"
              class="tw-w-full tw-h-full tw-object-cover tw-transition-transform tw-duration-300 hover:tw-scale-110"
              loading="lazy"
            />
            <div class="tw-absolute tw-inset-0 tw-bg-gradient-to-br tw-from-indigo-600/85 tw-via-indigo-700/90 tw-to-indigo-900/95 hover:tw-from-indigo-600/90 hover:tw-via-indigo-700/95 hover:tw-to-indigo-900/98 tw-transition-all tw-duration-300"></div>
          </div>
          <div class="tw-relative tw-p-8 tw-h-full tw-flex tw-flex-col tw-justify-between">
            <div>
              <div class="tw-w-12 tw-h-12 tw-bg-white/20 tw-backdrop-blur-sm tw-rounded-xl tw-flex tw-items-center tw-justify-center tw-mb-4 tw-transition-all tw-duration-300 hover:tw-bg-white/30 hover:tw-scale-110 hover:tw-rotate-6">
                <svg class="tw-w-6 tw-h-6 tw-text-white tw-transition-transform tw-duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                </svg>
              </div>
              <h3 class="tw-text-lg tw-font-bold tw-text-white tw-mb-3 tw-drop-shadow-lg tw-transition-transform tw-duration-300">Dedicated Support</h3>
              <p class="tw-text-white/95 tw-leading-relaxed tw-text-sm tw-drop-shadow-md">Expert team available throughout your event lifecycle</p>
            </div>
          </div>
        </div>
      </div>
      <div class="tw-text-center tw-mt-12">
        <a
          :href="appConfig.calendlyUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="tw-inline-block tw-text-primary-600 tw-font-semibold hover:tw-text-primary-700 tw-transition-colors tw-text-base"
        >
          Schedule a Call →
        </a>
      </div>
    </div>
  </section>
</template>

<script setup>
import appConfig from '../config/app.config.js';
</script>
